"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const pageContainer_module_scss_1 = __importDefault(require("./pageContainer.module.scss"));
const PageContainer = ({ children, variant = 'primary' }) => {
    return (0, jsx_runtime_1.jsx)("main", { className: (0, classnames_1.default)(pageContainer_module_scss_1.default.pageContainer, pageContainer_module_scss_1.default[`variant_${variant}`]), children: children });
};
exports.default = PageContainer;
